import React, { useState } from 'react';
import { propTypes } from 'react-modal';

const NavigationItem = ({ links = [], contentLink = null, directLinkList, isStoreWebsite, eyeHealthClinicLink }) => {    
    const currentPathName = location.pathname;
    const [navbarDisplayed, setNavbarDisplayed] = useState(false);
    let menuRef = React.createRef();
    function toggleMenu() {
        menuRef.current.classList.toggle('navbar__menu--show');
        document.body.classList.toggle('mobile-menu-displayed');
        setNavbarDisplayed(!navbarDisplayed);
    }
    const additionClass = contentLink && contentLink.attributes ? contentLink.attributes.cssValue : null;
    const selectedClass = contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;
    const hasNameOrChildren = link => link.name || (link.links || []).length > 0;

    const activeLinkClass = contentLink && contentLink.url != '#' && currentPathName && currentPathName === contentLink.url ? 'navbar__link-active' : '';

    return (
        <>
            {
                !navbarDisplayed
                    ? !contentLink ?
                        (<a className="navbar__link--block navbar__icon--menu navbar__icon" onClick={toggleMenu}></a>)

                        : (
                            <>
                                <a className={`navbar__link ${selectedClass} ${hasChildrenClass || ''} ${additionClass || ''} ${activeLinkClass}`} href={contentLink.url || '#'} dangerouslySetInnerHTML={{ __html: contentLink.name }} ></a>
                                {links.length > 0 && <i className="navbar__icon--caret-right navbar__icon navbar__icon--open" onClick={toggleMenu}></i>}
                            </>

                        )
                    : !contentLink ? (
                        <span className="navbar__icon navbar__icon--close" onClick={toggleMenu}></span>
                    ) : (
                        <>
                            <i className="navbar__icon--caret-left navbar__icon" onClick={toggleMenu}></i>
                            <span className="navbar__title" onClick={toggleMenu} dangerouslySetInnerHTML={{ __html: contentLink.name }}></span>
                        </>
                    )
            }

            
            {links.length > 0 &&
                <ul className={`navbar__menu  ${!isStoreWebsite ? "" : "white-navbar"}`} ref={menuRef}>
                    {!isStoreWebsite ? <li><div id="quickSearch"></div></li> : null}
                    {links.length > 0 && links.map((link, i) => hasNameOrChildren(link) &&
                        <li className={'navbar__item' + ((links.length - 1) === i ? ' navbar_item_last' : '')} key={link.url}>
                            <NavigationItem links={link.links} contentLink={link} />
                        </li>
                    )}
                    {
                        directLinkList ? (
                            <ul className="navbar__menu-direct-link-list">
                                {directLinkList.map(item => {
                                    const activeLinkClass = item && item.href && currentPathName && currentPathName === item.href ? 'navbar__menu-direct-link-active' : '';
                                    return <li key={item.href}>
                                        <a className={activeLinkClass} href={item.href}>
                                            {item.text}
                                        </a>
                                    </li>
                                })}
                            </ul>
                        ) : undefined
                    }
                    {eyeHealthClinicLink && <ul>
                        <li className='navbar__ehc-link'>
                            <a className='button-navy' href={eyeHealthClinicLink.href}>{eyeHealthClinicLink.text}</a>
                        </li>                        
                    </ul>}

                </ul>
            }            

        </>
    )
}

export default NavigationItem;